import { ref, type Ref, type App, inject } from 'vue'
import { useIntervalFn } from '@vueuse/core'

interface Plugin {
    isWorkingHoursUk: Readonly<Ref<boolean>>
}

const key = 'app.plugin.working-hours'

const getIsWorkingHours = () => {
    const now = new Date(
        new Date().toLocaleString('en-US', { timeZone: 'Europe/London' })
    )
    return !(now.getHours() < 11 || now.getHours() > 17 || now.getDay() === 0)
}

export function installIskWorkingHoursUkPlugin(app: App): Plugin {
    const plugin = createIsWorkingHoursUkPlugin()

    app.provide(key, plugin)

    return plugin
}

const createIsWorkingHoursUkPlugin = (): Plugin => {
    const isWorkingHoursUk = ref(getIsWorkingHours())

    // eslint-disable-next-line vue-composable/composable-placement
    useIntervalFn(
        () => {
            isWorkingHoursUk.value = getIsWorkingHours()
        },
        60_000,
        {
            immediate: true,
        }
    )

    return {
        isWorkingHoursUk,
    }
}

export function useIsWorkingHoursUk(): Plugin {
    return inject(key) as Plugin
}
